import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourBuild from "./sections/StartYourBuild";
import FindUs from "./sections/FindUs";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourBuild />
      <FindUs />
      <Footer />
    </div>;
}